const demoDate = (dayOffset, hour = 9, minute = 0) => {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + dayOffset);
  date.setHours(hour, minute, 0, 0);
  return date.toISOString();
};

export const mockTaskSellers = [
  { id: 'seller_001', name: 'Nathan' },
  { id: 'seller_002', name: 'David' },
  { id: 'seller_003', name: 'Emma' },
];

export const mockTaskContacts = [
  {
    id: 'cus_001',
    name: 'Sophie Martin',
    email: 'sophie.martin@example.com',
    phone: '+33600000000',
    segment: 'VIP',
    assignedSellerId: 'seller_001',
  },
  {
    id: 'cus_002',
    name: 'Monsieur Laurent',
    email: 'laurent@example.com',
    phone: '+33611111111',
    segment: 'Client fidèle',
    assignedSellerId: 'seller_002',
  },
  {
    id: 'cus_003',
    name: 'Claire Bernard',
    email: 'claire.bernard@example.com',
    phone: '+33622222222',
    segment: 'Anniversaire proche',
    assignedSellerId: 'seller_003',
  },
];

export const mockTaskProjects = [
  {
    id: 'project_001',
    contactId: 'cus_001',
    title: 'Projet bague de fiançailles',
    status: 'active',
    budget: 4000,
    currency: 'EUR',
    productsCount: 2,
    createdAt: demoDate(-23, 9),
  },
  {
    id: 'project_002',
    contactId: 'cus_001',
    title: 'Sélection anniversaire',
    status: 'sent',
    budget: 3200,
    currency: 'EUR',
    productsCount: 2,
    createdAt: demoDate(-37, 14),
  },
  {
    id: 'project_003',
    contactId: 'cus_002',
    title: 'Bracelets favoris',
    status: 'active',
    budget: 900,
    currency: 'EUR',
    productsCount: 3,
    createdAt: demoDate(-22, 11),
  },
];

export const mockTasks = [
  {
    id: 'task_001',
    title: 'Relancer Sophie pour la bague essayée',
    description:
      'Elle hésite entre deux modèles. Lui envoyer une sélection avec les disponibilités en taille 52.',
    status: 'todo',
    priority: 'high',
    type: 'follow_up',
    dueDate: demoDate(1, 10),
    createdAt: demoDate(-2, 14, 30),
    updatedAt: demoDate(-2, 14, 30),
    assignedTo: {
      id: 'seller_001',
      name: 'Nathan',
    },
    linkedContactId: 'cus_001',
    linkedProjectId: 'project_001',
    linkedCloseCircleMemberId: 'circle_001',
    closeCircleMemberName: 'Paul Dupont',
    linkedConversationId: null,
    linkedProductId: null,
    reminder: {
      enabled: true,
      date: demoDate(1, 9, 30),
    },
    activity: [
      {
        id: 'activity_001',
        type: 'created',
        label: 'Suivi créé',
        createdAt: demoDate(-2, 14, 30),
        actor: {
          id: 'seller_001',
          name: 'Nathan',
        },
      },
    ],
  },
  {
    id: 'task_002',
    title: 'Envoyer la sélection WhatsApp',
    description: 'Envoyer les trois bracelets favoris du client.',
    status: 'todo',
    priority: 'medium',
    type: null,
    dueDate: demoDate(0, 23),
    createdAt: demoDate(-1, 11),
    updatedAt: demoDate(-1, 11),
    assignedTo: {
      id: 'seller_002',
      name: 'David',
    },
    linkedContactId: 'cus_002',
    linkedProjectId: null,
    linkedCloseCircleMemberId: null,
    closeCircleMemberName: '',
    linkedConversationId: 'conversation_001',
    linkedProductId: null,
    reminder: {
      enabled: false,
      date: null,
    },
    activity: [
      {
        id: 'activity_002',
        type: 'created',
        label: 'Suivi créé',
        createdAt: demoDate(-1, 11),
        actor: {
          id: 'seller_002',
          name: 'David',
        },
      },
    ],
  },
  {
    id: 'task_003',
    title: 'Appeler Claire avant son anniversaire',
    description: 'Préparer deux idées de cadeau discrètes avant l’appel.',
    status: 'in_progress',
    priority: 'high',
    type: null,
    dueDate: demoDate(-2, 9, 30),
    createdAt: demoDate(-5, 9),
    updatedAt: demoDate(-3, 16),
    assignedTo: {
      id: 'seller_003',
      name: 'Emma',
    },
    linkedContactId: 'cus_003',
    linkedProjectId: null,
    linkedCloseCircleMemberId: null,
    closeCircleMemberName: '',
    linkedConversationId: null,
    linkedProductId: null,
    reminder: {
      enabled: true,
      date: demoDate(-2, 9),
    },
    activity: [
      {
        id: 'activity_003',
        type: 'created',
        label: 'Suivi créé',
        createdAt: demoDate(-5, 9),
        actor: {
          id: 'seller_003',
          name: 'Emma',
        },
      },
      {
        id: 'activity_004',
        type: 'status_changed',
        label: 'Statut passé en cours',
        createdAt: demoDate(-3, 16),
        actor: {
          id: 'seller_003',
          name: 'Emma',
        },
      },
    ],
  },
  {
    id: 'task_005',
    title: 'Préparer le message de suivi Saint-Valentin',
    description:
      'Relancer avec une formulation courte et premium autour de la sélection déjà envoyée.',
    status: 'todo',
    priority: 'high',
    type: null,
    dueDate: demoDate(0, 23, 15),
    createdAt: demoDate(-1, 17, 20),
    updatedAt: demoDate(-1, 17, 20),
    assignedTo: {
      id: 'seller_001',
      name: 'Nathan',
    },
    linkedContactId: 'cus_001',
    linkedProjectId: null,
    linkedConversationId: null,
    linkedProductId: null,
    reminder: {
      enabled: true,
      date: demoDate(0, 23),
    },
    activity: [
      {
        id: 'activity_007',
        type: 'created',
        label: 'Suivi créé',
        createdAt: demoDate(-1, 17, 20),
        actor: {
          id: 'seller_001',
          name: 'Nathan',
        },
      },
    ],
  },
  {
    id: 'task_006',
    title: 'Confirmer la disponibilité des bracelets',
    description:
      'Vérifier les trois références favorites avant de répondre à Monsieur Laurent.',
    status: 'todo',
    priority: 'medium',
    type: null,
    dueDate: demoDate(0, 23, 30),
    createdAt: demoDate(0, 8, 10),
    updatedAt: demoDate(0, 8, 10),
    assignedTo: {
      id: 'seller_002',
      name: 'David',
    },
    linkedContactId: 'cus_002',
    linkedProjectId: null,
    linkedConversationId: null,
    linkedProductId: null,
    reminder: {
      enabled: false,
      date: null,
    },
    activity: [
      {
        id: 'activity_008',
        type: 'created',
        label: 'Suivi créé',
        createdAt: demoDate(0, 8, 10),
        actor: {
          id: 'seller_002',
          name: 'David',
        },
      },
    ],
  },
  {
    id: 'task_007',
    title: 'Envoyer une idée cadeau à Claire',
    description:
      'Partager une proposition discrète par email avec une option de rendez-vous samedi.',
    status: 'todo',
    priority: 'medium',
    type: null,
    dueDate: demoDate(2, 14),
    createdAt: demoDate(0, 9, 5),
    updatedAt: demoDate(0, 9, 5),
    assignedTo: {
      id: 'seller_003',
      name: 'Emma',
    },
    linkedContactId: 'cus_003',
    linkedProjectId: null,
    linkedConversationId: null,
    linkedProductId: null,
    reminder: {
      enabled: true,
      date: demoDate(2, 13, 30),
    },
    activity: [
      {
        id: 'activity_009',
        type: 'created',
        label: 'Suivi créé',
        createdAt: demoDate(0, 9, 5),
        actor: {
          id: 'seller_003',
          name: 'Emma',
        },
      },
    ],
  },
  {
    id: 'task_008',
    title: 'Préparer le rendez-vous de Sophie',
    description:
      'Mettre de côté les deux bagues essayées et imprimer les informations de taille.',
    status: 'todo',
    priority: 'high',
    type: 'appointment',
    dueDate: demoDate(0, 23, 45),
    createdAt: demoDate(0, 10, 15),
    updatedAt: demoDate(0, 10, 15),
    assignedTo: {
      id: 'seller_001',
      name: 'Nathan',
    },
    linkedContactId: 'cus_001',
    linkedProjectId: 'project_001',
    linkedConversationId: null,
    linkedProductId: null,
    reminder: {
      enabled: true,
      date: demoDate(0, 23, 30),
    },
    activity: [
      {
        id: 'activity_010',
        type: 'created',
        label: 'Suivi créé',
        createdAt: demoDate(0, 10, 15),
        actor: {
          id: 'seller_001',
          name: 'Nathan',
        },
      },
    ],
  },
  {
    id: 'task_009',
    title: 'Noter le retour client après essayage',
    description:
      'Ajouter les préférences de style et les objections principales dans la fiche client.',
    status: 'todo',
    priority: 'low',
    type: null,
    dueDate: demoDate(-1, 17, 45),
    createdAt: demoDate(-2, 12),
    updatedAt: demoDate(-2, 12),
    assignedTo: {
      id: 'seller_001',
      name: 'Nathan',
    },
    linkedContactId: 'cus_001',
    linkedProjectId: null,
    linkedConversationId: null,
    linkedProductId: null,
    reminder: {
      enabled: false,
      date: null,
    },
    activity: [
      {
        id: 'activity_011',
        type: 'created',
        label: 'Suivi créé',
        createdAt: demoDate(-2, 12),
        actor: {
          id: 'seller_001',
          name: 'Nathan',
        },
      },
    ],
  },
  {
    id: 'task_004',
    title: 'Vérifier disponibilité taille 52',
    description: 'Confirmer le stock pour le projet alliance.',
    status: 'done',
    priority: 'medium',
    type: null,
    dueDate: demoDate(-3, 12),
    createdAt: demoDate(-4, 10, 15),
    updatedAt: demoDate(-3, 11, 45),
    assignedTo: {
      id: 'seller_001',
      name: 'Nathan',
    },
    linkedContactId: 'cus_001',
    linkedProjectId: null,
    linkedConversationId: null,
    linkedProductId: null,
    reminder: {
      enabled: false,
      date: null,
    },
    activity: [
      {
        id: 'activity_005',
        type: 'created',
        label: 'Suivi créé',
        createdAt: demoDate(-4, 10, 15),
        actor: {
          id: 'seller_001',
          name: 'Nathan',
        },
      },
      {
        id: 'activity_006',
        type: 'completed',
        label: 'Suivi terminé',
        createdAt: demoDate(-3, 11, 45),
        actor: {
          id: 'seller_001',
          name: 'Nathan',
        },
      },
    ],
  },
];
